import { Colors } from "../../../consts/Colors";

export default class ButtonInput extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);
        this.selected = false;

        this.addBody()        

        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
                this.animationDot();
                if(this.selected){
                    this.setNormal();
                }else{
                    this.setSelected();
                }
                clickFunction(this);
        }, this.scene);
    }

    addBody(){

        // Fond
        this.background = this.scene.add.rexRoundRectangle(0, 0, 56, 24, 12, Colors.Elmt.Grey);
        this.add(this.background);

        // Ombre fond
        this.shadow = this.scene.add.image(0, 0, 'button_shadow');
        this.add(this.shadow);

        // Bordure
        this.border = this.scene.add.rexRoundRectangle(0, 0, 56, 24, 12, Colors.Elmt.DarkerGrey);
        this.border.setFillStyle(Colors.Elmt.White, 0);
        this.border.setStrokeStyle(2, Colors.Elmt.DarkerGrey);
        this.add(this.border);

        // Dot
        this.dot = this.scene.add.circle(-16, 0, 9, Colors.Elmt.GreyBlue);
        this.add(this.dot);

        this.setSize(this.background.width, this.background.height);
    }

    pointerOver(){
        // Ajout de l'animation du hover
    }

    pointerOut(){
        // Ajout de l'animation du hover        
    }

    setSelected(){
        this.selected = true;
        this.dot.setFillStyle(Colors.Elmt.Orange);
        this.background.setFillStyle(Colors.Elmt.White);
        this.border.setStrokeStyle(1, Colors.Elmt.Orange);
    }

    setNormal(){
        this.selected = false;
        this.dot.setFillStyle(Colors.Elmt.GreyBlue);
        this.background.setFillStyle(Colors.Elmt.Grey);
        this.border.setStrokeStyle(2, Colors.Elmt.DarkerGrey);
    }

    setFalse(){
        this.dot.setFillStyle(Colors.Elmt.Red);
        this.border.setStrokeStyle(2, Colors.Elmt.Red);

    }

    animationDot(){
        // Animation du dot
        this.scene.tweens.add({
            targets: this.dot,
            x: -this.dot.x,
            duration: 200,
            ease: 'Sine.easeInOut',
        });
    }
}